<template>
  <router-view/>
</template>

<script>
export default {
  name:  '',
  data() {
    return {

    }
  },
  created() {
    this.$i18n.locale = "en";
  }
}
</script>

<style scoped lang="scss">

</style>
